import styles from './styles.module.css'

import Image from '@/shared/components/Image/new'
import Video from '../Video';
import SocialLinks from '../Social';
import Author from '../Author'

export const Liveblogs = (props) => {

    const CONTENT_DEFAULT_CLIPPING = "Vertical_Libre_870x0"

    const dateParagraphTemplate = (dateParagraph = '', index) => {

        const originalDate = dateParagraph.split(" ");

        const date = originalDate[0];
        const datePart = date.split("-");
        const formattedDate = `${datePart[2]}.${datePart[1]}`;
        
        
        const onlyDate = date.split("-");
        const day = parseInt(onlyDate[2], 10);
        const month = parseInt(onlyDate[1], 10);
        const year = parseInt(onlyDate[0], 10);

        const objetDate = new Date(year, month - 1, day); 
                                                            //Se busca nombre del dia por medio del numero 
        const dayWeekNUmber = objetDate.getDay();

        const weekdays = ["Domingo", "Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado"];

        const nameDayWeek = weekdays[dayWeekNUmber];

        
        return (
            <>
                {dateParagraph && (
                    <>
                       {index != 0 && <div className={`${styles["social-container"]}`}>
                                        <SocialLinks url={props.customProps.url} />
                                      </div>}
                    
                        <div className={index != 0 ? styles['line'] : ''}></div>

                        <span className={styles['date-update']}>{nameDayWeek} {formattedDate}</span>
                    </>
                )}
            </>
        )
    }


    const authorTemplate = (authorParagraph) => {

        const parseObjectAuthorParagraph = {
            ...authorParagraph,
            imageUrl: authorParagraph?.imageUrl.replace('http://img-ellitoral.lilax.io', process.env.NEXT_PUBLIC_IMAGE_DOMAIN)
        }
        
        return authorParagraph && <div className={styles['author-container']}>
                                    <Author author={parseObjectAuthorParagraph}/>
                                  </div>
    }


    const textTemplate = (data, index) => {
        let parseTitle;
        if(data.value.includes('h2')) {

            const originalDate = data?.dateParagraph && data?.dateParagraph.split(" ");
            const hour = originalDate?.[1].slice(0, 5);

           const firstPartHtmlTitle = data.value.slice(0, 4)        // Se formatea el h1 para poder agregar la hora como un span
           const secondPartHtmlTitle = data.value.slice(4)
           const hourHtml = !data.rating ? `<span>${hour}</span>` : `<span style='color: red'>${hour}</span>`
           parseTitle = `${firstPartHtmlTitle}${hourHtml} ${secondPartHtmlTitle}`
        
        } else {
            parseTitle = data.value
        }
        
        return <>
            
            {dateParagraphTemplate(data?.dateParagraph, index)}

            {authorTemplate(data?.authorParagraph)}
            
            <div className={styles['paragraph']} style={{ color: data.rating ? 'red' : '' }} dangerouslySetInnerHTML={{ __html: parseTitle }}></div>
        </>
    }


    const embedTemplate = (data) => {
        return <div className={styles['embed-container']} dangerouslySetInnerHTML={{ __html: data.value?.html }}></div>
    }


    const imageTemplate = (data) => {

        const defaultClipping = data.value?.clippings.filter(el => el._id === CONTENT_DEFAULT_CLIPPING)
        const newClippingImg = !data.value?.manualCrops?.[0] ? defaultClipping[0] : data.value?.manualCrops?.[0]

        const finalClipping = !newClippingImg ? data.value?.clippings?.[0] : newClippingImg
        const imgLiveblogs = `${process.env.NEXT_PUBLIC_IMAGE_DOMAIN}/images${finalClipping?.url}`
        
        return <Image
        src={imgLiveblogs}
        width={finalClipping?.dimensions?.width}
        height={finalClipping?.dimensions?.height}
        className={styles['cover-image']}
        />
    }


    const videoTemplate = (data) => {
        return <div className={styles['video-container-liveblogs']}>
                <Video content={data.value}/>
               </div>
    }


    const getDynamicTemplate = (data, index) => {

        switch (data.type) {
            case "text": {
                return textTemplate(data, index);
            }

            case "embed": {
                return embedTemplate(data);
            }

            case "image": {
                return imageTemplate(data); 
            }
            
            case "video": {
                return videoTemplate(data); 
            }
        }

        return false;
    }


    return (
        <div className={styles['container-liveblog']}>
           
            {props.content.body.map((el, i, array) => {
                const CustomTemplate = getDynamicTemplate(el, i);
                return <div key={i}>{CustomTemplate}</div>
            })
            }
            <div className={`${styles["social-container"]}`}>
                <SocialLinks url={props.customProps.url} />
            </div>
        </div>
        )
}